import { Component, OnInit, OnDestroy, HostListener, HostBinding, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { KeyboardService } from 'src/app/services/keyboard.service';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.css']
})
export class KeyboardComponent implements OnInit {

  @HostBinding('class.shown')
  private shown: boolean;

  private keyboardSubscription: Subscription;
  pressedKeys: string[] = [];
  inputValue: string = '';
  inputType: string = '';

  constructor(private el: ElementRef, private keyboard: KeyboardService) {
  }
  ngOnInit() {
    this.keyboardSubscription = this.keyboard.keyboardRequested.subscribe(show => {
      if (show) {
        const w = window.innerWidth;
        if (w <= 900) {
          this.inputType = this.keyboard.keyboardtype;
          this.shown = true;
        }
      }
      else {
        this.shown = false;
      }
    });

    this.keyboardSubscription = this.keyboard.pressedKeys$.subscribe(keys => {
      this.inputValue = keys.join('');
    });
  }

  ngOnDestroy() {
    this.keyboardSubscription.unsubscribe();
  }

  onShift() {
    this.keyboard.shift = !this.keyboard.shift;
  }

  onAlt() {
    this.keyboard.alt = !this.keyboard.alt;
    this.keyboard.shift = false;
  }

  onBackspace() {
    this.keyboard.fireBackspacePressed();
  }

  onEnter() {
    this.keyboard.fireEnterPressed();
  }

  updateInputValue() {
    this.inputValue = this.pressedKeys.join(''); // Actualiza el valor del campo de entrada
  }


  @HostListener('mousedown', ['$event'])
  @HostListener('click', ['$event'])
  onMouseEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

}
